import { gql } from "@apollo/client"
import { RestrictiveCovenants } from "@oysterhr/schema"

export const RestrictiveCovenantsSectionFragment = gql`
  fragment RestrictiveCovenantsSectionFragment on RestrictiveCovenants {
    confidentiality
    nonCompetition
    nonSolicitation
    nonSolicitationCustomers
    nonSolicitationEmployees
    postTerminationDurationMonths
    postTerminationAmountAbsoluteSubunit
    postTerminationAmountPercentage
    postTerminationPaymentFrequency
    postTerminationAcknowledged
    postTerminationRestrictedArea
    postTerminationAreaOfBusiness
    postTerminationAreaOfBusinessInLocalLanguage
    postTerminationAdditionalAreas
  }
`

export type RestrictiveCovenantsSectionFragment = Pick<
  RestrictiveCovenants,
  | "confidentiality"
  | "nonCompetition"
  | "nonSolicitation"
  | "nonSolicitationCustomers"
  | "nonSolicitationEmployees"
  | "postTerminationDurationMonths"
  | "postTerminationAmountAbsoluteSubunit"
  | "postTerminationAmountPercentage"
  | "postTerminationPaymentFrequency"
  | "postTerminationAcknowledged"
  | "postTerminationRestrictedArea"
  | "postTerminationAreaOfBusiness"
  | "postTerminationAreaOfBusinessInLocalLanguage"
  | "postTerminationAdditionalAreas"
>
